import { langService } from '@/core';

const plugin = {
  install(app) {
    app.config.globalProperties.$t = function (key, opt) {
      return langService.trans(key, opt);
    };

    app.config.globalProperties.$tc = function (key, plural, opt) {
      return langService.choice(key, plural, opt);
    };
  },
};

export default plugin;
